import jsonlint from 'jsonlint-mod';
import { Configuration, OpenAIApi } from 'openai';
import { useEffect, useState } from 'react';
import { useLanguageValue } from '../context/LanguageContext';

export const useAskChatGPT = () => {
  const api_key = process.env.REACT_APP_OPENAI_API_KEY;
  const org_key = process.env.REACT_APP_OPENAI_ORG_KEY;

  const configuration = new Configuration({
    organization: org_key,
    apiKey: api_key,
  });

  const openAi = new OpenAIApi(configuration);
  const { preferenceLanguage } = useLanguageValue();

  const [loading, setLoading] = useState(false);
  const [returnGPT, setReturnGPT] = useState("");
  const [textTranslated, setTextTranslated] = useState("");
  const [errorGPT, setErrorGPT] = useState("");
  const [cancelled, setCancelled] = useState(false);
  const [generateGPT, setGenerateGPT] = useState(false);

  let errorNumber = null;

  function checkAndFixJSON(jsonString) {
    try {
      const parsedJSON = jsonlint.parse(jsonString);
      return parsedJSON;
    } catch (error) {
      console.error("Erro ao parsear JSON:", error);
      setLoading(false);
      setErrorGPT(error);
      try {
        const fixedJSON = jsonString
          .replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": ')
          .replace(/'/g, '"')
          .replace(/:\s*"(\d{2}):\s*(\d{2}):\s*(\d{2})"/g, ':"$1:$2:$3"');

        const parsedFixedJSON = jsonlint.parse(fixedJSON);
        return JSON.stringify(parsedFixedJSON);
      } catch (error) {
        console.error("Erro ao corrigir JSON:", error);
        setLoading(false);
        setErrorGPT(error);
        return '';
      }
    }
  }

  const handleSetAssessment = (questions) => {
    const questionsFixed = checkAndFixJSON(questions);
    const assessmentFormated = questionsFixed;
    setReturnGPT(assessmentFormated);
  }

  const handleSetTranslate = (translate) => {

    const translateFixed = translate;

    if (translateFixed) {
      try {
        setReturnGPT(translateFixed);
      } catch (error) {
        setErrorGPT("Failed to parse JSON");
      }
    } else {
      setErrorGPT("Failed to parse JSON");
    }
  };

  const handleSplitTopics = (topics) => {

    let topicsFormatted;

    if (topics.includes(';')) {
      topicsFormatted = topics.split(';').map((topic) => topic.trim());
    } else {
      topicsFormatted = topics.split(/\d+[\.\)]\s/).filter(topic => topic.trim() !== '');
    }
    setReturnGPT(topicsFormatted);
  }

  function checkIfIsCancelled() {
    if (cancelled) {
      return;
    }
  }

  const handleOpenAiApi = async ({ subject, userInput, caseDescription, contentReviewed, selectedTopics, questionQ, choiceQ, feedback, level, language, orderGPT, objectSubtitle, notConsider, companySector, specificChallenges, companyObjectives }) => {

    checkIfIsCancelled();

    setLoading(true);
    setGenerateGPT(false);
    setErrorGPT(null);

    let userLanguage;

    if (preferenceLanguage === "Espanhol") {
      userLanguage = "spanish"
    } else if (preferenceLanguage === "Português") {
      userLanguage = "portuguese"
    } else {
      userLanguage = "english"
    }

    const content = userInput
      ? userInput
      : contentReviewed
        ? contentReviewed
        : null;
    const about = content ? `the following text: ${content}` : subject;
    let askGPT;
    let words = 1000;

    if (orderGPT === "topics") {
      askGPT = `List and rank in the ${userLanguage} language the 5 most important topics about ${about} in order of relevance, separating each topic with a semicolon (;). Do not include introductions or end messages.`;
    } else if (orderGPT === "assessment") {
      const topics = selectedTopics.length > 0
        ? `about the topics ${selectedTopics} of`
        : `about`;
      askGPT = `Consider the following rules: a ${level} level of difficulty while generating the questions. Only one correct answer per question. Do not create identical questions. Do not create text interpretation questions. Keep the text of each question clear, concise, and focused, with a minimum of 20 words. Ensure that each question has a single, unambiguous correct answer and that the distractors (incorrect options) are plausible but different from the correct answer. Avoid cues that may give away the correct answer or mislead learners. Distractors must be mutually exclusive. Avoid using absolute terms like "always", "never", or "only" in the correct answer. Avoid negative questions. Avoid nonsense words and unreasonable statements. ${feedback && `Include feedback text to complement and reinforce the correct answer, but do not use the words "Correct", "Correct Answer", "Congrats", "Very good", "Excellent", "Good job" or any indication of correctness.`} Randomize the correct answers. Considering all the rules above, create in ${language} ${questionQ} multiple-choice questions, with ${choiceQ} answer options each ${topics} ${about}. ${notConsider && `Please generate questions different from the following: ${notConsider}`}. 
        Important: Generate all the questions in ${language}.
        Return only the json as described below, without any additional text or explanations. Important: do not insert \`\`\`json before the JSON object.
        [{"ask_question": "xxxxxx xxxxx xxxxx xxxxxxx xxxxxx xxxxxxx xxxxxx xxxxxxxxx xxxxxx xx xxx xxxxxxxx xxxx xxxxx xxxxx xxx xxxxxxxxxx xxxx?",
          "alternatives": [
            {"option": "a", "text": "xxxxxxxxxx"},
            {"option": "b", "text": "xxxxxxxx"},
          ],
          "correct_answer": "",
          "feedback": "The correct answer is Washington..."}]`;
    } else if (orderGPT === "content") {
      const topics = selectedTopics.length > 0
        ? `about the topics ${selectedTopics} of`
        : `about`;
      askGPT = `
        Generate a content in the ${language} language with ${words} words, ${topics} ${about}. Provide a title, start with an introduction, and develop the text into 5 subjects with  subtitles. 
        Return only the json as described below, without any additional text or explanations. Important: do not insert \`\`\`json before the JSON object.:

      {
        "title": "xxxxxx xxxxx xxxxx",
        "intro": "xxxxxx xxxxx xxxxx",
        “topics”: [
            {
              “subtitle” : "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
              “content”: "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
            },
            {
              “subtitle” : "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
              “content”: "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
            },
            {
              “subtitle” : "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
              “content”: "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
            },
            {
              “subtitle” : "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
              “content”: "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
            },
            {
              “subtitle” : "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
              “content”: "xxx xxxxxxx xxxxxxxx xxxxx xxxxxxxx"
            }
        ],
        "conclusion": "xxxxxxxxxxxxxxx"
      }`;
    } else if (orderGPT === "case") {
      askGPT = `Generate a case in ${language} language about the subject ${subject} considering the following context ${caseDescription}. Case Introduction should provide a context for the case by introducing the involved company/organization and the sector in which it operates. Company Description provides an overview of the company, its mission, values, and history. Present relevant information about the company's size, target market, and competitive position. Problem Context explains the specific scenario that led to the problem or challenge and identify the main stakeholders involved and describe their interests and expectations. Problem or Challenge Description clearly detail the problem or challenge faced by the company and presents relevant data and information to support the severity of the problem. Problem Analysis conducts an in-depth analysis of the problem, identifying its root causes and potential impact, using appropriate analysis tools, such as SWOT analysis, stakeholder analysis, or risk analysis if applicable. Proposed Solution describes the recommended solution to resolve the problem or address the challenge and explains how this solution addresses the root causes of the problem and what its main benefits are. Solution Implementation details how the proposed solution was deployed in the company, describing the implementation process steps, required resources, and involved parties. Results and Impacts presents the results achieved after the implementation of the solution. Highlight the key performance indicators that have been positively impacted. Lessons Learned discuss the lessons learned throughout the process, highlighting the main insights and learnings of the company. Identify potential improvements or adjustments that could be made in the future. Conclusion provides a recap of the case and the main points addressed. Highlight the importance of the proposed solution and its benefits for the company. Concludes with an overview of future perspectives or recommendations for the company. Keep the text clear and with an empathetic tone.
      Return only the json as described below, without any additional text or explanations. Important: do not insert \`\`\`json before the JSON object.:
      { "title": "Case sobre ${subject}",
        intro : “xxxxxxxxxxxxxxx”,
        “company_description” : “xxxxxxxxxxxxxxx”,
        “problem_context”: “xxxxxxxxxxxxxxx”,
        “problem_or_challenge_description”: “xxxxxxxxxxxxxxxxxx”,
        “problem_analysis”: “xxxxxxxxxxxxxxx”,
        “proposed_solution”: “xxxxxxxxxxxxxxx”,
        “solution_implementation” : “xxxxxxxxxxxxxxx”,
        “results_and_impacts”: “xxxxxxxxxxxxxxx”,
        “lessons_learned”: “xxxxxxxxxxxxxxx”,
        “conclusion”: “xxxxxxxxxxxxxxx”}`
    } else if (orderGPT === "caseAssessment" || orderGPT === "userText") {
      askGPT = `Create ${questionQ} multiple-choice questions about ${about}. With ${choiceQ} answers options. Only one right answer per question. Do not create identical questions. Do not create text interpretation questions. Level of the questions: ${level}. ${feedback && `Include feedback text to complete the right answer.`} Write in ${language} language. Return only the json as described below, without any additional text or explanations.Important: do not insert \`\`\`json before the JSON object:
      [{"ask_question": "xxxxxx xxxxx xxxxx xxxxxxx xxxxxx xxxxxxx xxxxxx xxxxxxxxx xxxxxx xx xxx xxxxxxxx xxxx xxxxx xxxxx xxx xxxxxxxxxx xxxx?",
        "alternatives": [
          {"option": "a", "text": "Whashington"},
          {"option": "b", "text": "Chicago"},],
        "correct_answer": "",
        "feedback": "The correct answer is Washington..."}]`
    } else if (orderGPT === "translate") {
      const jsonString = JSON.stringify(objectSubtitle, null, 2);
       askGPT = `Translate the following text ${jsonString} to ${language}. Each element in the object should be translated individually and returned in the same position in the object. Ensure the JSON structure presented in text is maintained and return the result as a formatted JSON object in ${language}. Ensure that the structure, order of elements, and all characters (including commas, braces, brackets, colons, etc.) are preserved exactly as they are. Do not combine or split any elements. Maintain the line breaks and punctuation as they are. Return only the JSON, without any additional text or explanations. Do not modify or omit any part of the JSON structure. Important: do not insert \`\`\`json before the JSON object.`
    } else if (orderGPT === "translateSubtitle") {
      const jsonString = JSON.stringify(objectSubtitle, null, 2);
      askGPT = `Translate the following array of strings to ${language}. Each element in the array should be translated individually and returned in the same position in the array. Ensure that the structure and order of elements are preserved. Do not combine or split any elements. Maintain the line breaks and punctuation as they are. Return only the translated array of strings, without any additional text or explanations. Important: do not insert \`\`\`json before the JSON object. Here is the array: ${JSON.stringify(jsonString)}`;
    } else if (orderGPT === "summary") {
      askGPT = `Generate a summary in ${language} language considering ${content}. The summary should be concise and clear, covering the main points of the text. Avoid adding personal opinions or additional information. Return only the text of the summary, without any additional text or explanations.`;
    } else if (orderGPT === "supplementaryContent") {
      askGPT = `Based on the ${content}, suggest a list of supplementary content to deepen the learning on the topic covered in ${language} language. The list should include:
      Relevant Articles or Websites: Provide links to websites or articles that cover topics similar to the content of the video.
      Books: Suggest books that expand understanding and can be applied.
      Videos or Lectures: Indicate online videos or lectures that explore the concepts of the text and complement the learning.
      Please be sure that the suggested urls and videos belong to reliable sources and are up-to-date.
      The suggested resources should be easy to access and practically understandable for the profile of the employees. The list could be 4 to 7 items long. Return only the list of supplementary content, without any additional text or explanations.`;
    } else if (orderGPT === "videoCase") {
      askGPT = `Generate a case in ${language} language based on the ${content}, and the context of our company, which operates in the ${companySector} sector, develop a case study on the applicability of the concept presented in the video. This case should address common challenges faced by our employees, such as ${specificChallenges}, and show how the concept can be implemented to improve results in relation to ${companyObjectives}.
      The case should be clear and practical, with examples that help employees see how they can apply the concept in real situations in their daily work.
      Return only the json as described below, without any additional text or explanations. Important: do not insert \`\`\`json before the JSON object.:
      { "intro : “xxxxxxxxxxxxxxx”,
        “company_description” : “xxxxxxxxxxxxxxx”,
        “problem_or_challenge_description”: “xxxxxxxxxxxxxxxxxx”,
        “problem_analysis”: “xxxxxxxxxxxxxxx”,
        “proposed_solution”: “xxxxxxxxxxxxxxx”,
        “solution_implementation” : “xxxxxxxxxxxxxxx”,
        “results_and_impacts”: “xxxxxxxxxxxxxxx”,
        “lessons_learned”: “xxxxxxxxxxxxxxx”,
        “conclusion”: “xxxxxxxxxxxxxxx”}`;
    }
    else {
      askGPT = null
    }

    try {
      const makeApiCall = async () => {
        console.log(askGPT)
        const response = await openAi.createChatCompletion({
          model: 'o3-mini-2025-01-31',
          //model: 'gpt-4o-mini-2024-07-18',
          //model: 'gpt-3.5-turbo-16k',
          messages: [
            {
              role: 'user',
              content: askGPT,
            },
          ],
        });
        console.log("retorno GPT: " + response.data.choices[0].message.content);
        return response.data.choices[0].message.content;
      };

      const retryWithBackoff = async (maxAttempts, delay) => {
        let attempts = 0;

        while (attempts < maxAttempts) {

          try {
            const result = await makeApiCall();

            console.log("orderGPT: " + orderGPT);

            if(orderGPT === "summary" || orderGPT === "supplementaryContent" ) {
              setReturnGPT(result);
              return
            }

            if(orderGPT === "translate" ){
              const translateFixed = checkAndFixJSON(result);
              setReturnGPT(translateFixed);
              //setReturnGPT(result);
              return
            }

            if (orderGPT === "translateSubtitle") {
              handleSetTranslate(result);
              return
            }
            orderGPT === "topics"
              ? handleSplitTopics(result)
              : handleSetAssessment(result);
            setLoading(false);
            setGenerateGPT(true);
            return;
          } catch (error) {
            console.log(error);
            if (error.response) {
              switch (error.response.status) {
                case 500:
                  errorNumber = 500;
                  break;
                case 503:
                  errorNumber = 503;
                  break;
                case 408:
                  errorNumber = 408;
                  break;
                default:
                  errorNumber = 900;
              }
            }
            attempts++;

            if (attempts === maxAttempts) {
              switch (errorNumber) {
                case 500:
                  setErrorGPT('Erro no servidor da OpenAI. Tente novamente mais tarde.');
                  break;
                case 503:
                  setErrorGPT('Serviço da OpenAI indisponível. Tente novamente mais tarde.');
                  break;
                case 408:
                case 0:
                  setErrorGPT('Problemas de comunicação com o servidor. Verifique sua conexão e tente novamente.');
                  break;
                default:
                  setErrorGPT('Falha na chamada da OpenAI após várias tentativas. Tente novamente mais tarde.');
              }
            }
            await new Promise((resolve) => setTimeout(resolve, delay));
          }
        }
        setLoading(false);
      };

      await retryWithBackoff(3, 1000);
    } catch (error) {
      setErrorGPT(error);
    }
  };

  useEffect(() => {
    return () => setCancelled(true);
  }, []);

  return {
    handleOpenAiApi,
    returnGPT,
    textTranslated,
    loading,
    generateGPT,
    errorGPT
  }
}
